/* global G */
import find from 'lib/sequence/component/children/find'
import { asyncPipeSpread } from 'lib/util'
import { get } from 'lib/sequence/component/state/value'
import { enable, disable } from 'lib/sequence/component/state/disabled'
import asObject from 'lib/sequence/component/children/asObject'

/**
 * Displays the `generate` action based on the value of `content`.
 *
 * @param {Gaia.AppModule.Spec} module  current module
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
const displayGenerateAction = module => async (components, ...args) => {
  const { content } = components
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const actions = asObject(actionComponent[G.ACTIONS][0][G.CHILDREN])

  const { btnGenerate } = actions

  get(content)
    ? enable(btnGenerate)
    : disable(btnGenerate)

  return args
}

/**
 * OptionManagement Insert Action
 *
 * @param {Gaia.AppModule.Spec} module  current module
 */
export default module => component => async (...args) => asyncPipeSpread(
  displayGenerateAction(module),
)(find(component), ...args)
